export default __webpack_public_path__ + "static/media/icon-nota-fiscal.caa1e12d.svg";